<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Numer telefonu'"
      [data]="organization()?.telefon1"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'WWW'"
      [data]="organization()?.www"
      additionalCssClasses="font-bold"
      additionalCssClassesForTextData="break-all"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Adres e-mail'"
      [data]="organization()?.email"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
</div>
